module.exports = __webpack_public_path__ + "static/fonts/alfaslabone-regular.6a72b54.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/alfa/alfaslabone-regular.woff
// module id = aY1I
// module chunks = 1